import React from 'react';

import { Skeleton } from '@/components/ui/Skeleton';

export const BlogPostSkeleton: React.FC = () => {
  return (
    <article className="max-w-[44rem] mx-auto space-y-6 text-white">
      {/* Back link skeleton */}
      <Skeleton variant="text" width="140px" height="16px" />

      {/* Header skeleton */}
      <header className="space-y-4 pt-4">
        {/* Category and date */}
        <div className="flex items-center gap-3">
          <Skeleton variant="text" width="100px" height="14px" />
          <Skeleton variant="text" width="100px" height="14px" />
        </div>

        {/* Title */}
        <div className="space-y-2">
          <Skeleton variant="text" width="90%" height="40px" className="md:h-12" />
          <Skeleton variant="text" width="70%" height="40px" className="md:h-12" />
        </div>

        {/* Subtitle */}
        <div className="space-y-2">
          <Skeleton variant="text" width="85%" height="20px" />
          <Skeleton variant="text" width="75%" height="20px" />
        </div>

        {/* Tags */}
        <div className="flex flex-wrap gap-2">
          <Skeleton variant="rectangular" width="80px" height="28px" />
          <Skeleton variant="rectangular" width="100px" height="28px" />
          <Skeleton variant="rectangular" width="90px" height="28px" />
        </div>
      </header>

      {/* Thumbnail image skeleton */}
      <Skeleton variant="rectangular" className="w-full aspect-[16/9]" />

      {/* Body content skeleton */}
      <div className="mt-8 space-y-4">
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="95%" />
        <Skeleton variant="text" width="98%" />
        <Skeleton variant="text" width="92%" />
        <div className="pt-2" />
        <Skeleton variant="text" width="97%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="88%" />
        <div className="pt-2" />
        <Skeleton variant="text" width="94%" />
        <Skeleton variant="text" width="96%" />
        <Skeleton variant="text" width="90%" />
        <Skeleton variant="text" width="85%" />
      </div>

      {/* Share buttons skeleton */}
      <div className="mt-8 pt-8 border-t border-neutral-800">
        <Skeleton variant="text" width="120px" height="24px" className="mb-4" />
        <div className="flex gap-3">
          <Skeleton variant="rectangular" width="100px" height="44px" />
          <Skeleton variant="rectangular" width="100px" height="44px" />
          <Skeleton variant="rectangular" width="100px" height="44px" />
        </div>
      </div>
    </article>
  );
};
